import InputC from 'Common/Inputs/index.tsx';

const FiltersCM = ({
    setFilterdata,
    Filterdata = { text: '', key: 1 },
    headerData = [],
}) => {

    // Handle text input change
    const handleData = (e) => {
        const value = e?.target?.value ?? '';
        setFilterdata((prev) => ({
            ...prev,
            text: value,
        }));
    };
    // Build select options
    const options = [
        { label: 'All', value: 'All' },
        ...headerData
            .map(item => ({
                label: item.title,
                value: item.value,
            })),
    ].slice(0, -4);


    return (
        <div className="d-flex gap-2 align-items-end mb-3">
            {/* Search Input */}
            <InputC
                label="Search"
                type="text"
                name="label"
                className="w-15"
                inputvalue={Filterdata.text}
                placeholder="Enter Text"
                change={handleData}
                size="md"
            />

            {/* Select Filter */}
            <InputC
                type="select"
                className="w-15"
                size="sm"
                label="Key"
                placeholder="Select Field"
                inputvalue={Filterdata.key}
                isClearable={false}
                change={(e) =>
                    setFilterdata((prev) => ({
                        ...prev,
                        key: e?.value,
                    }))
                }
                options={options}
            />

            <InputC
                type="select"
                className="w-15"
                size="sm"
                label="Status"
                placeholder="Select Field"
                inputvalue={Filterdata.status}
                isClearable={false}
                change={(e) =>
                    setFilterdata((prev) => ({
                        ...prev,
                        status: e?.value,
                    }))
                }
                options={[
                    { label: 'All', value: 'All' },
                    { label: 'Published', value: 1 },
                    { label: 'Draft', value: 2 },
                    { label: 'Modified', value: 3 },
                    { label: 'Unpublish', value: 0 },
                ]}
            />
            <InputC
                type="select"
                className="w-15"
                size="sm"
                label="Sort By"
                placeholder="Select Field"
                inputvalue={Filterdata.orderType}
                isClearable={false}
                change={(e) =>
                    setFilterdata((prev) => ({
                        ...prev,
                        orderType: e?.value,
                    }))
                }
                options={[
                    { label: 'Created At', value: 1 },
                    { label: 'Updated At', value: 2 },
                ]}
            />
            <InputC
                type="select"
                className="w-15"
                size="sm"
                label="Order By"
                placeholder="Select Field"
                inputvalue={Filterdata.sortOrder}
                isClearable={false}
                change={(e) =>
                    setFilterdata((prev) => ({
                        ...prev,
                        sortOrder: e?.value,
                    }))
                }
                options={[
                    { label: 'Ascending', value: 2 },
                    { label: 'Decending', value: 1 },
                ]}
            />
        </div>
    );
};

export default FiltersCM;
